<template>
  <div>
    <el-table border :data='tableData'>
      <el-table-column prop="totalScore" label="总分" align="center">
      </el-table-column>
      <el-table-column prop="passScore" label="合格分数线" align="center">
      </el-table-column>
      <el-table-column prop="Score" label="你的分数" align="center">
      </el-table-column>
    </el-table>
    <div class='examinationBox'>
      <div class='examinationTitle'>{{ testPaperName }}</div>
      <div class='questionBox'>
        <div v-for='(items, indexs) in showData' :key='indexs' class='bigex'>
          <div class='exTitle'>
            {{ items.subjectName + '(共' + items.subjectNumber + '题' + items.subjectScore + '分)' }}
          </div>
          <div v-for='(item, index) in items.extendedData' :key='index' class='smallexbox'>
            <div v-if="item.questionType == '单选' || item.questionType == '判断'">
              <div class='smallexTitle'>
                {{ (index + 1) + '.(' + item.questionType + ')' + item.questionContent }}
                <div style='color:#009943' v-if='ifPass'><span>答案：</span>{{ item.needResult }}</div>
              </div>
              <div v-for='(itemsmall, indexsm) in item.list' :key='indexsm' class='exContent'>

                <el-radio v-model="item.radio" :disabled='ifPass' :label="itemsmall.uuid">{{ itemsmall.radio + '.' +
                  itemsmall.content }}</el-radio>
              </div>
            </div>
            <div v-if="item.questionType == '多选'">
              <div class='smallexTitle'>
                {{ (index + 1) + '.(' + item.questionType + ')' + item.questionContent }}
                <div style='color:#009943' v-if='ifPass'><span>答案：</span>{{ item.needResult }}</div>
              </div>
              <div v-for='(itemsmall, indexsm) in item.list' :key='indexsm' class='exContent'>
                <el-checkbox :disabled='ifPass' v-model="itemsmall.selectResult">{{ itemsmall.radio + '.' +
                  itemsmall.content }}</el-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 50px;">
      <el-button v-if='!ifPass' style="float: right;" type="primary" @click='detail_save'>交卷</el-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    eqId: {
      default: false
    },
    eqexaminationData: {
      default: false,
      type: Object
    }
  },
  data() {
    return {
      firstData: {},
      showData: [],
      tableData: [{ totalScore: '', passScore: '', Score: '' }],
      testPaperName: ''
    }
  },
  methods: {
    init() {
      this.ifPass = this.eqexaminationData.pass
      this.firstData = this.ifPass ? JSON.parse(JSON.stringify(this.eqexaminationData.appraisalTestPaperResult)) : JSON.parse(JSON.stringify(this.eqexaminationData.appraisalTestPaper))
      this.testPaperName = this.firstData.testPaperName
      this.tableData[0].Score = this.ifPass ? this.eqexaminationData.appraisalTestPaperResult.achievement : ''
      this.showData = JSON.parse(JSON.stringify(this.firstData.subjectList))
      this.showData.forEach(item => {
        item.extendedData = JSON.parse(item.extendedData)
      })
      this.showData.forEach((item1, index1) => {
        item1.extendedData.forEach((item2, index2) => {
          this.$set(this.showData[index1].extendedData[index2], 'resultquest', [])
          this.showData[index1].extendedData[index2].list.forEach((item, index) => {
            if (this.showData[index1].extendedData[index2].list[index].selectQuest) {
              this.showData[index1].extendedData[index2].resultquest.push(this.showData[index1].extendedData[index2].list[index].radio)
            }
          })
          this.$set(this.showData[index1].extendedData[index2], 'needResult', this.showData[index1].extendedData[index2].resultquest.join(','))

        })
      })
      this.tableData[0].totalScore = this.eqexaminationData.appraisalTestPaper.totalScore
      this.tableData[0].passScore = this.eqexaminationData.appraisalTestPaper.passScore
    },
    handleClose() {
      this.$emit('close')
    },
    detail_save() {
      this.firstData.subjectList = JSON.parse(JSON.stringify(this.showData))
      this.firstData.subjectList.forEach((bigitem, indexbg) => {
        bigitem.extendedData.forEach((item, index) => {
          if (bigitem.extendedData[index].questionType == '单选' || bigitem.extendedData[index].questionType == '判断') {
            this.showData[indexbg].extendedData[index].list.forEach((itemsmall, indexs) => {
              if (item.radio == itemsmall.uuid) {
                this.$set(this.firstData.subjectList[indexbg].extendedData[index].list[indexs], 'selectResult', true)
              }
            })
          }
        })
      })
      this.firstData.subjectList.forEach((bigitemS, indexbgS) => {
        this.$set(this.firstData.subjectList[indexbgS], 'appraisalTestPaperSubjectId', this.firstData.subjectList[indexbgS].id)
        this.firstData.subjectList[indexbgS].extendedData = JSON.stringify(this.firstData.subjectList[indexbgS].extendedData)
      })
      this.$set(this.firstData, 'appraisalTestPaperId', this.firstData.id)
      this.$net(`/sdau/userClient/appraisal/answer`, 'post', this.firstData).then(res => {
        this.tableData[0].Score = res.data.score
        this.ifPass = res.data.pass
        if (this.ifPass) {
          this.$message({
            type: 'success',
            message: this.tableData[0].Score + '分,考试通过'
          })
          this.$emit('submitExamination')
        }
        else {
          this.$message({
            type: 'warning',
            message: this.tableData[0].Score + '分,考试未通过'
          })
          this.init()
        }
      })
    },
  },
  created() {
    this.init()
  }
}
</script>
<style lang="scss" scoped>
::v-deep.el-table {
  width: 25%;
  position: absolute;
  right: 40px;
  top: 10px;

  thead tr th {
    font-size: 12px;
    font-weight: normal;
  }
}

::v-deep.examinationBox {
  padding: 16px 32px 32px 32px;

  .examinationTitle {
    text-align: center;
    font-size: 20px;
    font-weight: 800;
    color: #000;
  }

  .questionBox {
    margin-top: 32px;
    overflow: auto;
    max-height: 400px;

    .bigex {
      .exTitle {
        font-size: 18px;
        font-weight: 600;
        color: #000;
        margin-bottom: 8px;
        margin-top: 16px;
      }

      .smallexbox {
        padding-left: 16px;

        .smallexTitle {
          font-size: 16px;
          color: #000;
          margin-bottom: 8px;
          margin-top: 8px;
        }

        .exContent {
          margin-bottom: 4px;
          padding-left: 4px;
        }
      }
    }
  }
}
</style>